import { useSearch } from '@tanstack/react-router';

const useEmptySearchParams = () => {
    const { page, page_size, ordering, ...rest } = useSearch({});
    return Object.keys(rest).length === 0;
};

export default useEmptySearchParams;
